export const addItem = (product) => {
    return {
        type : "ADDITEM",
        payload : product
    }
}

export const delItem = (product) => {
    return {
        type : "DELITEM",
        payload : product
    }
}

export const clearCart = () => {
    return {
        type : "CLEAR_CART"
    }
}

// In your cart reducer file
export const cartReducer = (state = [], action) => {
    switch (action.type) {
      case 'CLEAR_CART':
        return []; // This clears the cart by returning an empty array
      // other cases...
      default:
        return state;
    }
  };